import { type Slide } from './_data';
import { useSlidesContent } from './context';
import { getSlidePageNumber } from './utils';

export const useSlidePageNumber = (slide: Slide<any>): number => {
  const { slides } = useSlidesContent();
  return getSlidePageNumber(slides, slide);
};
